import { IconButton, Menu, MenuItem } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { useMenu } from '../../../../hooks/use-menu';
import { getProductDotMenuLabel } from '../create-plan-page-consts/product-dot-menu-consts';

type ProductDotMenuDropdownProps = {
  onCreateGroup: () => void;
  onDeleteGroup: () => void;
  isGrouped: boolean;
};

export default function ProductDotMenuDropdown({
  onCreateGroup,
  onDeleteGroup,
  isGrouped,
}: ProductDotMenuDropdownProps) {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  function handleGroupingClick() {
    if (isGrouped) {
      onDeleteGroup();
    } else {
      onCreateGroup();
    }

    handleMenuClose();
  }

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <VyIcon icon="DotsMenu" />
      </IconButton>

      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleGroupingClick}>
          {getProductDotMenuLabel({ isGrouped })}
        </MenuItem>
      </Menu>
    </>
  );
}
